export enum HeaderType {
  HEADER_BLACK_SCIENCE = 'header_black_science',
  HEADER_INLINE_WITH_LOGO = 'header_inline_with_logo',
  HEADER_LONGREAD = 'header_longread',
  HEADER_ON_SPORT = 'header_on_sport',
  HEADER_WITH_BIG_LOGO = 'header_with_big_logo',
}
